export class GblReportheaderModality {
    ReportheaderModalityId: number;
    ReportheaderId: number;
    ReportheaderName: string;
    ModalityId?: number;
    ModalityName: string;
    OrgId?: number;
    CreatedBy?: number;
    CreatedOn?: Date;
    LastModifiedBy?: number;
    LastModifiedOn?: Date;
}